import type { MoveToSetPhase, MoveToSetProgress } from "./useMoveToSetBatch.js";

const PHASE_LABELS: Record<MoveToSetPhase, string> = {
  checking: "checking family-mates",
  writing: "writing",
};

export function describeMoveToSetProgress({
  batch,
  totalBatches,
  testimonialType,
  phase,
  processedRows,
  totalRows,
}: MoveToSetProgress): string {
  const detail = [testimonialType, phase ? PHASE_LABELS[phase] : null].filter(Boolean).join(", ");
  return `batch ${batch} / ${totalBatches}${detail ? ` (${detail})` : ""}, rows ${processedRows} / ${totalRows}`;
}
